export const FOIL = "foil";
export const EPEE = "epee";
export const SABRE = "sabre";

export const getWeaponTypes = [FOIL, EPEE, SABRE];
export const getAllWeaponTypes = [FOIL, EPEE, SABRE, null];

export default getWeaponTypes;
